module.exports = __webpack_public_path__ + "img/search.ede48e82.svg";